orders-planner-line-back
  span.btn.btn-sm.btn-outline-danger.waves-effect.waves-dark.icon-btn(if="{this.isShow}" onClick="{onClick}")
    i.feather.icon-skip-back
  script(type="typescript").
    this.mixin('orders.planner.line-back');
